import logo from './resources/media/Unstable Muffin Co.svg'
import './App.css';
import {BrowserRouter, Link, Route, Routes} from 'react-router-dom';
import {Home} from "./pages/Home";
import {Projects} from "./pages/Projects";
import {About} from "./pages/About";
import {Muffins} from "./pages/Muffins";
import {Software} from "./pages/Software";
import {Random} from "./pages/Random";

function App() {
    return (
        <BrowserRouter>
            <div className="app">
                <header className="app-header">
                    <Link to="/">
                        <img src={logo} alt={'unstable muffin co logo'} className="logo"/>
                    </Link>

                    <nav>
                        <span className="nav-text be-vietnam-pro-semibold">
                            &lt;a&gt; <br/>
                            <Link className="nav-link primary-green" to="/projects">creative studio</Link> <br/>
                            by <Link className="nav-link primary-yellow" to="/about">sam hoffmann</Link> <br/>
                            from <Link className="nav-link primary-red" to="/muffins">muffins</Link> <br/>
                            to <Link className="nav-link primary-blue" to="/software">software</Link> <br/>
                            and <Link className="nav-link secondary-blue" to="/random">everything between</Link> <br/>
                            &lt;/a&gt;
                        </span>
                    </nav>
                </header>

                <div className="router-continer">
                    <Routes>
                        <Route path="/projects" element={<Projects/>}/>
                        <Route path="/about" element={<About/>}/>
                        <Route path="/muffins" element={<Muffins/>}/>
                        <Route path="/software" element={<Software/>}/>
                        <Route path="/random" element={<Random/>}/>
                        <Route path="/" element={<Home/>}/>
                    </Routes>
                </div>
            </div>
        </BrowserRouter>
    );
}

export default App;
